import classNames from 'classnames';
import Button from 'components/generics/buttons/Button';
import classes from 'components/generics/forms/TradeForm/components/TradeFormConfirm/index.module.scss';
import React, { HTMLAttributes } from 'react';
import { parseMoney } from 'utils/money_utils';

interface Props extends HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  onConfirm?: () => void;
  moneyAmount?: number;
  goToOrderPage?: () => void;
}

const DebtFormConfirm = ({
  className,
  disabled,
  onConfirm,
  moneyAmount,
}: Props) => {
  return (
    <div className={classNames(classes.container, className)}>
      <Button
        className={classes.buyButton}
        disabled={disabled}
        onClick={onConfirm}
      >
        Coming Soon
        {/* {disabled ? 'Continue' : `Invest ${parseMoney(moneyAmount)}`} */}
      </Button>
    </div>
  );
};

export default DebtFormConfirm;
